import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { LoginIdService } from "./login-id.service";
import {Observable} from "rxjs/Observable";

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  options = {};

  constructor(private httpClient: HttpClient, private loginIdService: LoginIdService) { }

    /**
     * Get the number of all documents for a user
     *
     * @return Observable containing the number of all documents for a user
     */
  public getDocumentCount(): Observable<number>{
    let httpOptions = {
      headers: this.loginIdService.getCurrentCustomHeadersWithoutSpinner()
    }
    return this.httpClient.get<number>("/api/document-count", httpOptions);
  }

    /**
     * Get the number of all special documents for a user. A document is special when its corresponding product hat special = true
     *
     * @return Observable containing the number of all special documents for a user
     */
  public getSpecialDocumentCount(): Observable<number>{
    let httpOptions = {
      headers: this.loginIdService.getCurrentCustomHeadersWithoutSpinner()
    }
    return this.httpClient.get<number>("/api/document-count/special", httpOptions);
  }

    /**
     * Get the number of all bauakten documents for a user
     *
     * @return Observable containing the number of all bauakten documents for a user
     */
  public getBauaktenDocumentCount(): Observable<number>{
    return this.httpClient.get<number>("/api/document-count/bauakten", {headers: new HttpHeaders({'showing-spinner': ''})})
  }
}
